
export default {
    API_URL: 'https://api.cognition.link/v1'
}